import React from "react";

import { CommonToast, UserInfoField, CommonButton } from "common/components";
import { errorMessages } from "common/utils/validation";
import { Formik, Form } from "formik";
import { Grid, CircularProgress } from "@material-ui/core";
import { StoreState } from "common/store/types";
import { UpdateUser } from "common/graphql/queryDescriptors";
import { useCustomQuery } from "common/store/hooks/useCustomQuery";
import { User } from "common/store/user/types";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

export const SingleUserFieldForm = ({ id }: any) => {
  //State
  const [toastOpen, setToastOpen] = React.useState(false);

  //Hooks
  const { t } = useTranslation();

  const storageUserDetails = useSelector<StoreState, User>(
    (state) => state.currentUser
  );

  let { execute: executeUpdateUserDetails, loading } = useCustomQuery(
    UpdateUser({
      onSuccess: () => {
        setToastOpen(true);
      },
    })
  );

  //Validation
  const onValidate = (values: User) => {
    const errors: any = new User(values).validate([id], errorMessages);

    return errors;
  };

  const onSubmit = async (values: User, { setSubmitting }: any) => {
    setSubmitting(true);

    const data = new User(values).updateRequest();

    await executeUpdateUserDetails({ variables: data });

    setSubmitting(false);
  };

  return (
    <>
      <Formik
        enableReinitialize
        validate={onValidate}
        onSubmit={onSubmit}
        initialValues={storageUserDetails}
      >
        {({
          submitForm,
          isSubmitting,
          setFieldValue,
          values,
          errors,
          touched,
        }) => {
          const props = {
            values,
            errors,
            touched,
            setFieldValue,
            disableImmutable: false,
          };

          return (
            <Form autoComplete="off">
              <Grid container direction="row" spacing={5}>
                <Grid item xs={12} sm={6}>
                  <UserInfoField id={id} {...props} />
                </Grid>

                <Grid item xs={12} sm={6}>
                  {loading || isSubmitting ? (
                    <CircularProgress />
                  ) : (
                    <CommonButton
                      onClick={submitForm}
                      className="primary--medium"
                      isSubmitting={isSubmitting}
                      values={values}
                      errors={errors}
                      touched={touched}
                      text={t("Update")}
                    />
                  )}
                </Grid>
              </Grid>
            </Form>
          );
        }}
      </Formik>

      <CommonToast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        text={t("Changes saved!")}
        severity={"success"}
      />
    </>
  );
};
